// API helper for tunggakan summary (arrears)
import { getCurrentUserDepartment } from "utils/userUtils";
import { apiRequest } from "./dashboard";

// Get aging report (for Laporan)
export const apiGetAgingReport = async (zon = null, startDate = null, endDate = null) => {
  try {
    let paramsArr = [];
    if (zon) paramsArr.push(`zon=${encodeURIComponent(zon)}`);
    if (startDate) paramsArr.push(`startDate=${encodeURIComponent(startDate)}`);
    if (endDate) paramsArr.push(`endDate=${encodeURIComponent(endDate)}`);
    const params = paramsArr.length ? `?${paramsArr.join("&")}` : "";
    const data = await apiRequest(`/tunggakan/aging-report${params}`);
    return data;
  } catch (error) {
    console.error("Error fetching aging report:", error);
    return {
      aging_till6: 0,
      aging7_12: 0,
      aging13_18: 0,
      aging19_24: 0,
      aging25_30: 0,
      aging31_36: 0,
      aging37_72: 0,
      aging73_120: 0,
      aging_more120: 0,
    };
  }
};

export const apiGetTunggakanSummary = async () => {
  try {
    const userDepartment = getCurrentUserDepartment();
    const data = await apiRequest(
      `/dashboard/tunggakan-summary?department=${encodeURIComponent(userDepartment)}`
    );
    return data;
  } catch (error) {
    console.error("Error fetching tunggakan summary:", error);
    return { totalOutstanding: 0, countUnpaid: 0, details: [] };
  }
};

// Per-zon unpaid invoice sums within a period [startDate, endDate]
export const apiGetTunggakanPerZon = async (startDate, endDate) => {
  try {
    const userDepartment = getCurrentUserDepartment();
    const params = new URLSearchParams();
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);
    if (userDepartment) params.set("department", userDepartment);
    const qs = params.toString() ? `?${params.toString()}` : "";
    const data = await apiRequest(`/tunggakan/per-zon${qs}`);
    return data; // { data: [{zon, jumlah}], total }
  } catch (error) {
    console.error("Error fetching tunggakan per zon:", error);
    return { data: [], total: 0 };
  }
};

export default {
  apiGetTunggakanSummary,
};
